import axios, { Axios } from "axios";

const api: Axios = axios.create();

api.interceptors.response.use(
    response => response,
    error => {
      console.log(error);
      if (error.response?.status === 403 &&
          error.response?.data?.error === "ACCESS_DENIED") {
        // Swap out app with static error page
        window.location.href = "/blocked.html";
      }
      return Promise.reject(error);
    }
);

export default api;